import { useSelector } from "react-redux";
import { UPLOAD_MAP_TO_FILTER_ID, UPLOAD_MAP_FILTER_ID } from "../../../../../config/constant/curatorConstants";
import { curatorStylesSelector } from "../../../../../redux/slicers/admin/curatorStylesSlicer";
import { filterSelector } from "../../../../../redux/slicers/filters/filterSlicer";

export const useFilterOption = ({ defaultTilingType } = {}) => {
  const selectMapMode = useSelector((state) => curatorStylesSelector(state).selectMapMode);
  const tilingType = typeof selectMapMode === 'number' ? selectMapMode : defaultTilingType;
  
  const { filterData } = useSelector(filterSelector)
  const filter = getMapFilter(tilingType, filterData?.results);

  return {
    filter,
    // tilingType: selectMapMode,
  }
}

export const getMapFilter = (tilingType, filters) => {
  filters = filters || [];
  const uploadMapFilters = filters.find(f => f.id === UPLOAD_MAP_FILTER_ID)
  const filterId = UPLOAD_MAP_TO_FILTER_ID[tilingType];
  const filter = uploadMapFilters?.options?.find(f => f.id === filterId)
  
  return filter;
}